import {
  getLocalPhoneDigits,
  hasInvalidPhoneAreaCode,
  PHONE_DIGIT_COUNT,
} from 'shared/utils/string/phone';
import { z } from 'zod';

const phoneValidationMessages = {
  invalidAreaCode: 'Enter a valid area code',
  invalidLength: 'Number must be 10 digits',
  required: 'Required',
};

const socurePhoneSchema = z
  .string({ error: phoneValidationMessages.required })
  .min(1, { error: phoneValidationMessages.required })
  .refine((value) => !hasInvalidPhoneAreaCode(value), {
    error: phoneValidationMessages.invalidAreaCode,
  })
  .refine((value) => getLocalPhoneDigits(value).length === PHONE_DIGIT_COUNT, {
    error: phoneValidationMessages.invalidLength,
  });

export const socureDesktopSchema = () =>
  z.object({
    phone: socurePhoneSchema,
  });
